import { UPDATE_COUPON, UPDATE_COUPON_SUCCESS, UPDATE_COUPON_ERROR, UPDATE_COUPON_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateCoupon = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_COUPON:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_COUPON_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPDATE_COUPON_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case UPDATE_COUPON_EMPTY:
      state = {
        data: null,
        message: null,
        loading: false,
        success: false,
        error: false,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateCoupon;
